import React, { Component } from "react";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";

import { Carousel } from "react-responsive-carousel";

class Home extends Component {
  state = {
    slideIndex: 0
  };
  componentWillMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="home">
        <div className="home__mainHeader">
          <Carousel
            showIndicators={false}
            showThumbs={false}
            showStatus={false}
            infiniteLoop={true}
            // autoPlay={true}
          >
            <div>
              <img src="./assets/1.jpg" />
            </div>
            <div>
              <img src="./assets/2.jpg" />
            </div>
            <div>
              <img src="./assets/3.jpg" />
            </div>
          </Carousel>
          <h1>
            Welcome to <span>MED</span> <span>Source</span> International
          </h1>
          <h3>Other services will tell you promises – ours is in writing</h3>
        </div>
        <div className="home__contentContainer">
          <div className="home__contentContainer__paragraphContainer">
            <div className="home__contentContainer__paragraphContainer__paragraph">
              <p>
                Our mission is simple, to help any cut their out-of-pocket
                medication expenses. <br /> Med Source International has been
                helping people from coast to coast save up to 90% on their
                prescription medications. <br /> When you order, there are no
                membership or club fees.{" "}
              </p>
            </div>
            <div className="home__contentContainer__paragraphContainer__secondParagraph">
              <h3>
                Your satisfaction is the reason why we offer an industry leading
                Triple Guarantee
              </h3>
              <div className="home__contentContainer__paragraphContainer__secondParagraph__column">
                <i className="fas fa-money-bill-alt" />
                <p>Price Guarantee</p>
                <Link to="price-guarantee">Learn More</Link>
              </div>
              <div className="home__contentContainer__paragraphContainer__secondParagraph__column">
                <i className="fas fa-smile" />
                <p>Satisfaction Guarantee</p>
                <Link to="satisfaction-guarantee">Learn More</Link>
              </div>
              <div className="home__contentContainer__paragraphContainer__secondParagraph__column">
                <i className="fas fa-shipping-fast" />
                <p>30 Day Shipping Guarantee</p>
                <Link to="shipping">Learn More</Link>
              </div>
              <div className="clearfix" />
            </div>
          </div>
          <div className="home__wideContent">
            <div className="home__wideContent__container">
              <div className="home__wideContent__container__heading">
                <h3>
                  Other services will tell you promises <br /> ours is in
                  writing.
                </h3>
              </div>
              <div className="home__wideContent__container__stamp">
                <img src="./assets/stamp.png" alt="" />
              </div>
              <div className="clearfix" />
            </div>
          </div>
          <div className="home__description">
            <h3>
              If you find it harder than ever to pay for your prescription
              medications, Med Source International will work with you to help
              you save.
            </h3>
            <br />
            <p>
              Med Source International works hard to bring prescription savings
              to your door. All medications are dispensed by licensed
              pharmacies. Our Canadian pharmacy is fully staffed with licensed
              pharmacy technicians and pharmacists.
            </p>
            <br />
            <p>
              Unlike other “online” pharmacies that have been in business for a
              handful of years, our pharmacy has been trusted by over 500,000
              satisfied customers.
            </p>
            <br />
            <p>
              When you order your medications from a pharmacy that we contract
              with, you can feel secure knowing that our prescription service
              holds your safety as our top priority.
            </p>
            <br />
            <p>
              At Med Source International, we do not sacrifice quality for
              savings. All medications ordered from Med Source International are
              dispensed from a licensed Canadian pharmacy. If you’re looking to
              save even more on your prescription drugs, ask us if your
              medication comes in a generic.
            </p>
            <br />
            <p>
              Similar to your local pharmacy, prescription drugs require an
              original doctor's prescription and we must receive your
              prescription prior to completing your order. You can send your
              prescription to us, or we can contact your doctor to request your
              prescription at no additional charge.
            </p>
            <br />
            <h3>Saving money on prescription drugs is not just for seniors.</h3>
            <br />
            <p>
              We help people with high drug copays, the self-employed, the
              unemployed, Medicare recipients and people with health saving
              accounts (HSA’s) save more. Compare and save. <br /> We stand
              behind our Price Guarantee -{" "}
              <Link to="price-guarantee">Learn More</Link>
            </p>
            <br />
            <p>
              Please contact our customer service department if you have any
              questions or would like to get a price quote.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/Home.js